export const selectBuildInfo = (state) => state.deployCheck?.buildInfo;

export const selectDeployId = (state) => state.deployCheck?.deployId;

export const selectLatestTag = (state) => state.deployCheck?.buildInfo?.latestTag;
